'use strict';

angular.module('cf.app')
.directive('cfMultiLineEditor', ['require', require => {
  var createTextarea = require('editors').textarea;

  return {
    restrict: 'E',
    scope: {},
    require: '^cfWidgetApi',
    link: function ($scope, $el, _$attrs, widgetApi) {
      var editor = createTextarea(widgetApi);
      $el.append(editor);

      // This is necessary to free the component for garbage collection.
      // Otherwise the component is kept in a cache somewhere.
      $scope.$on('$destroy', () => {
        $el.empty();
      });
    }
  };
}]);



// WEBPACK FOOTER //
// ./src/javascripts/app/widgets/cf_multi_line_editor_directive.js